import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import SocialBehanceIcon from '@redbubble/design-system/src/Icons/SocialBehance';
import SocialDeviantArtIcon from '@redbubble/design-system/src/Icons/SocialDeviantArt';
import SocialDribbbleIcon from '@redbubble/design-system/src/Icons/SocialDribbble';
import SocialFacebookIcon from '@redbubble/design-system/src/Icons/SocialFacebook';
import SocialFlickrIcon from '@redbubble/design-system/src/Icons/SocialFlickr';
import SocialInstagramIcon from '@redbubble/design-system/src/Icons/SocialInstagram';
import SocialPinterestIcon from '@redbubble/design-system/src/Icons/SocialPinterest';
import SocialThreadsIcon from '@redbubble/design-system/src/Icons/SocialThreads';
import SocialTikTokIcon from '@redbubble/design-system/src/Icons/SocialTikTok';
import SocialTumblrIcon from '@redbubble/design-system/src/Icons/SocialTumblr';
import SocialWebsiteIcon from '@redbubble/design-system/src/Icons/SocialWebsite';
import SocialXIcon from '@redbubble/design-system/src/Icons/SocialX';
import SocialYouTubeIcon from '@redbubble/design-system/src/Icons/SocialYouTube';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';
import styles from './ArtistProfile.module.scss';
import { ArtistExternalLinksProps } from './types';

const messages = defineMessages({
  artistSocialLinksTitle: {
    defaultMessage: 'Artist social links',
  },
});

const iconLookup: Record<string, React.ComponentType> = {
  behance: SocialBehanceIcon,
  deviant_art: SocialDeviantArtIcon,
  dribbble: SocialDribbbleIcon,
  facebook: SocialFacebookIcon,
  flickr: SocialFlickrIcon,
  instagram: SocialInstagramIcon,
  pinterest: SocialPinterestIcon,
  tumblr: SocialTumblrIcon,
  twitter: SocialXIcon,
  other: SocialWebsiteIcon,
  tiktok: SocialTikTokIcon,
  youtube: SocialYouTubeIcon,
  threads: SocialThreadsIcon,
};

const linkOrder = [
  'other',
  'pinterest',
  'instagram',
  'tiktok',
  'youtube',
  'facebook',
  'threads',
  'deviant_art',
  'flickr',
  'dribbble',
  'behance',
  'twitter',
  'tumblr',
];

export const ArtistExternalLinks: React.FC<ArtistExternalLinksProps> = ({
  externalSites,
}) => {
  const intl = useIntl();

  if (!externalSites || externalSites.length === 0) return null;

  const siteMap = externalSites.reduce<
    Record<string, { url: string; Icon: React.ComponentType }>
  >((acc, site) => {
    const Icon = iconLookup[site.site];
    if (Icon) {
      acc[site.site] = { url: site.url, Icon };
    }
    return acc;
  }, {});

  return (
    <Box marginTop="l">
      <Text type="display3">
        {intl.formatMessage(messages.artistSocialLinksTitle)}
      </Text>
      <Box className={styles.externalSites} display="flex" flexDirection="row">
        {linkOrder.map((site) => {
          const entry = siteMap[site];
          if (!entry) return null;
          const { url, Icon } = entry;
          return (
            <Box className={styles.externalSitesButton} key={site}>
              <Button
                circle
                strong
                size={constants.SMALL}
                href={url}
                rel="noopener noreferrer"
              >
                <Icon />
              </Button>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
